<template>
  <div>
    <vue-headful :title="doctitle" />
    <b-container fluid>
      <b-row>
        <b-col class="p-0">
          <!-- Program mobile top img -->
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742477959/2025/Program_page/program_mobile.png"
            fluid-grow
            class="d-md-none"
          >
          </b-img>
          <!-- Program desktop top background -->
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742460341/2025/Program_page/background.png"
            fluid-grow
            class="d-none d-md-block"
          >
          </b-img>
          <!-- Floating spaceship desktop -->
          <b-img
            class="position-absolute d-none d-md-block"
            style="width: 29%; left: 10%; top: 0%; z-index: 0"
            src="https://res.cloudinary.com/oredev/image/upload/v1742477953/2025/spaceship.gif"
            alt=""
            aria-hidden="true"
          ></b-img>
          <!-- Program desktop top Forground -->
          <b-img
            class="position-absolute d-none d-md-block"
            src="https://res.cloudinary.com/oredev/image/upload/v1742460341/2025/Program_page/Forground.png"
            style="width: 100%; left: 0%; top: 8%; z-index: 0"
            alt=""
            aria-hidden="true"
          >
          </b-img>
        </b-col>
      </b-row>
    </b-container>
    <b-container
      fluid
      class="text-center position-relative mt-5 mb-5"
      style="max-width: 1900px"
    >
      <b-row>
        <b-col>
          <h1>This year's program</h1>
          <p class="title-paragraph mb-0">
            Discover the latest software trends explained by industry experts.
          </p>
        </b-col>
      </b-row>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/pink_planet.png"
        class="position-absolute title-image"
        style="width: 8%; left: 6%; top: 0%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Footer_pages/rocket_img.png"
        class="position-absolute title-image"
        style="width: 16%; right: 2%; top: 70%"
        alt=""
        aria-hidden="true"
      />
    </b-container>

    <b-container fluid>
      <b-row class="day-buttons">
        <b-col class="text-center">
          <button
            v-for="day in days"
            :key="day.value"
            @click="selectedDay = day.value"
            :class="{ active: selectedDay == day.value }"
            class="btn-mint"
          >
            {{ day.label }}
          </button>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="text-center">
          <p class="date-paragraph mb-5">
            {{
              [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
              ][selectedDay]
            }}, November {{ selectedDay + 2 }}, 2025
          </p>
        </b-col>
      </b-row>
    </b-container>

    <ScheduleGrid :selectedDay="selectedDay" />

    <!-- Mobile Bottom Images -->
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
      class="d-block d-sm-none mx-auto my-5"
      style="width: 36vw"
      alt=""
      aria-hidden="true"
    />
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_11.png"
      class="d-block d-sm-none mx-auto"
      style="width: 86vw"
      alt="A dancer in a costume of green netting"
    />
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 10vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute"
        style="top: 3vw; left: 43vw; max-width: 12vw"
        alt=""
        aria-hidden="true"
      />
    </b-container>
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_4.png"
        class="position-absolute"
        style="width: 25vw; left: 4vw; bottom: -6vw"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_5.png"
        class="position-absolute"
        style="width: 25vw; left: 36vw; bottom: -13vw"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_3.png"
        class="position-absolute"
        style="width: 25vw; left: 64vw; bottom: -6vw"
      />
    </b-container>
  </div>
</template>

<script>
import ScheduleGrid from "@/components/ScheduleGrid.vue";

export default {
  name: "Program",
  components: { ScheduleGrid },
  data() {
    return {
      doctitle: "Program - " + this.$store.state.conferencename,
      days: [
        { label: "Wednesday", value: 3 },
        { label: "Thursday", value: 4 },
        { label: "Friday", value: 5 },
      ],
      selectedDay: 3, // Default selected day
    };
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 48px;
  }
}

.title-paragraph {
  font-family: Lexend, sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 100%;
  letter-spacing: 0;
  @media (min-width: 768px) {
    font-size: 24px;
  }
}

.title-image {
  display: none;
  @media (min-width: 1200px) {
    display: block;
  }
}

.day-buttons {
  margin-bottom: 16px;
  @media (min-width: 768px) {
    margin-bottom: 56px;
  }
}

.date-paragraph {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.05rem;
  @media (min-width: 577px) {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Program.vue